import { useEffect } from 'react';
import { getGraphInQuery } from '../../lib/location';
import { useIsPreloadingGraph, useSetNewGraph } from '../../hooks';
import workerPool from '../../workers/pool';
export default function GraphPreloader() {
    var _a = useIsPreloadingGraph(), _ = _a[0], setIsPreloadingGraph = _a[1];
    var setGraph = useSetNewGraph();
    useEffect(function () {
        var graphUrl = getGraphInQuery();
        // Do we need to preload the graph from an url?
        if (!graphUrl) {
            return;
        }
        setIsPreloadingGraph(true);
        workerPool.import({ type: 'url', url: graphUrl }, function (err, _a) {
            var graph = _a.graph, model = _a.model;
            setIsPreloadingGraph(false);
            setGraph(graph, model);
        });
    }, []);
    return null;
}
